export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface ShowSortFilterType {
  sortOption: SortFilterOption<server.dto.ShowSort>
}

export const DefaultShowSortFilter: server.dto.ShowSort = "dateAsc";

export const ShowSortOptions = (): Array<SortFilterOption<server.dto.ShowSort>> => [
  {
    label: RESX.GeneralLabels.Name,
    value: "eventName",
    enabled: true
  },
  {
    label: RESX.DateTime.lblDate,
    value: "dateAsc",
    enabled: true
  },
  {
    label: `${RESX.DateTime.lblDate} ${RESX.GeneralLabels.Descending}`,
    value: "dateDesc",
    enabled: true
  },
  {
    label: site.currentEnvironment.functionGroups.artist.singular,
    value: "artist",
    enabled: site.currentEnvironment.functionGroups.artist.enabled
  },
  {
    label: site.currentEnvironment.functionGroups.venue.singular,
    value: "venue",
    enabled: site.currentEnvironment.functionGroups.venue.enabled
  },
  {
    label: site.currentEnvironment.functionGroups.promoter.singular,
    value: "promoter",
    enabled: site.currentEnvironment.functionGroups.promoter.enabled
  },
  {
    label: RESX.Financial.Costs,
    value: "costsAsc",
    enabled: site.permissions.show.canReadCosts
  },
  {
    label: RESX.Financial.Sales,
    value: "salesAsc",
    enabled: site.permissions.show.canReadSales
  },
  {
    label: RESX.GeneralLabels.LastModified,
    value: "lastModifiedDesc",
    enabled: true
  },
  {
    label: RESX.RecordInformation.CreatedOn,
    value: "createdDesc",
    enabled: true
  },
  {
    label: RESX.Planning.NotYetChecked,
    value: "notYetChecked",
    enabled: true
  }
];

export const getSortOption = (value: server.dto.ShowSort) => {
  return ShowSortOptions().find(s => s.value === value);
};

export const initialShowSortFilter: ShowSortFilterType = {
  sortOption: site.currentEnvironment ? getSortOption(DefaultShowSortFilter) : null,
};
